module.exports = __webpack_public_path__ + "img/winerackdog.342862f0.png";